import React, { Fragment } from "react";

import "./StatsStripV6.scss";

const DEFAULT_STATS = [
  {
    value: "R$ 100 bilhões",
    label: (
      <Fragment>
        anuais movimentados<br />
        através do Mercos
      </Fragment>
    )
  },
  {
    value: "18.000.000",
    label: (
      <Fragment>
        de pedidos realizados por<br />
        ano na plataforma
      </Fragment>
    )
  },
  {
    value: "+250",
    label: (
      <Fragment>
        ERPs<br />
        integrados
      </Fragment>
    )
  },
  {
    value: "56.000",
    label: (
      <Fragment>
        usuários<br />
        ativos
      </Fragment>
    )
  },
  {
    value: "+9.000",
    label: "clientes"
  }
];

const StatsStripV6 = ({ items = DEFAULT_STATS, className = "" }) => (
  <div className={`stats-strip stats-strip-v6-preview ${className}`.trim()}>
    {items.map((item, index) => (
      <div className="stats-strip-v6-preview__item" key={`${item.value}-${index}`}>
        <p className="stats-strip-v6-preview__value">{item.value}</p>
        <p className="stats-strip-v6-preview__label">{item.label}</p>
      </div>
    ))}
  </div>
);

export default StatsStripV6;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/StatsStripV6/StatsStripV6.jsx